import { Divider, Paper } from '@mui/material';
import { ClaimEventResponseItem } from 'API';
import { GeneralData } from '../Sections/SectionItem/GeneralData';
import { ProgressAndInformation } from './ProgressAndInformation';
import { useIsDesktop } from 'Hooks';
import {
  getLastStepIndex,
  getRecognitionStatusSteps,
} from 'Utils/recognitionStatusHelperFunctions';

export interface IClaimEventSteps {
  name: string;
  endDate?: string;
}

interface ISingleSection {
  claimEvent: ClaimEventResponseItem;
}

export const SingleClaimEvent = ({ claimEvent }: ISingleSection) => {
  const isDesktop = useIsDesktop();
  const latestEvent = claimEvent.claimEvents.at(-1);

  const claimEventSteps: IClaimEventSteps[] =
    getRecognitionStatusSteps(claimEvent);
  const currentStepIndex: number = getLastStepIndex(claimEvent);

  return (
    <Paper
      sx={{
        borderRadius: '16px',
        border: '1px solid #B7CCFF',
        bgcolor: '#FFF',
        padding: isDesktop ? '24px 24px 32px 24px' : '16px 16px 24px 16px',
        maxWidth: '640px',
        boxShadow: 'none',
        minWidth: isDesktop ? '925px' : '100%',
      }}
    >
      <GeneralData
        matter={claimEvent.pgimaDescription}
        treatmentStage={{
          stepId: latestEvent?.treatStepsGroupId,
          decisionType: latestEvent?.decisionType,
          isCurrentStep: true,
        }}
        updateDate={latestEvent?.statusDate}
        isSingleClaimEventView
        nextStep={claimEventSteps[currentStepIndex + 1]?.name}
      />
      {currentStepIndex > -1 && (
        <>
          <Divider sx={{ borderColor: '#E7EDFF', m: '24px 0 32px 0' }} />
          <ProgressAndInformation
            claimEventSteps={claimEventSteps}
            currentStepIndex={currentStepIndex}
            latestEvent={latestEvent}
          />
        </>
      )}
    </Paper>
  );
};
